/* eslint-disable import/no-extraneous-dependencies */
import { useEffect, useState } from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

type AnimatedMarkdownProps = {
  content: string
  speed?: number // milliseconds per character
  scrollTargetRef?: React.RefObject<HTMLElement>
}

function AnimatedMarkdown({
  content,
  speed = 15,
  scrollTargetRef
}: AnimatedMarkdownProps) {
  const [displayedText, setDisplayedText] = useState('')

  useEffect(() => {
    let i = 0
    const id = setInterval(() => {
      i++
      setDisplayedText(content.slice(0, i))
      scrollTargetRef?.current?.scrollIntoView({ behavior: 'auto' })
      if (i >= content.length) clearInterval(id)
    }, speed)

    return () => clearInterval(id)
  }, [content, speed, scrollTargetRef])

  return (
    <ReactMarkdown remarkPlugins={[remarkGfm]}>{displayedText}</ReactMarkdown>
  )
}

export default AnimatedMarkdown
